// main.js — Entry point; wires all modules
// theme.js — Dark/light toggle with clip-circle reveal
// canvas.js — Upward-drifting char particle system
const $125994b31ba2cef4$var$CHARS = "01/{|}[]<>:;!@#*\u223F\u232C\u25CC\xb7\u203B\u2295\u2218\u25CB+\xd7\xf7\u2248\u221E_\u2014";
const $125994b31ba2cef4$var$PALETTE_DARK = [
    '#00bf72',
    '#00e68a',
    '#4ecdc4',
    '#c8f5e1',
    '#6b9e82',
    '#3d9e6a'
];
const $125994b31ba2cef4$var$PALETTE_LIGHT = [
    '#1a5c38',
    '#0f3d24',
    '#2d6a5a',
    '#4a7060',
    '#1f7a50',
    '#327050'
];
let $125994b31ba2cef4$var$canvas, $125994b31ba2cef4$var$ctx;
let $125994b31ba2cef4$var$particles = [];
let $125994b31ba2cef4$var$animId = null;
let $125994b31ba2cef4$var$frame = 0;
let $125994b31ba2cef4$var$w = 0, $125994b31ba2cef4$var$h = 0;
let $125994b31ba2cef4$var$isDark = true;
let $125994b31ba2cef4$var$paused = false;
const $125994b31ba2cef4$var$PARTICLE_COUNT = 70;
function $125994b31ba2cef4$var$palette() {
    return $125994b31ba2cef4$var$isDark ? $125994b31ba2cef4$var$PALETTE_DARK : $125994b31ba2cef4$var$PALETTE_LIGHT;
}
function $125994b31ba2cef4$var$randomFrom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
function $125994b31ba2cef4$var$makeParticle(spawnAtBottom = true) {
    return {
        x: Math.random() * $125994b31ba2cef4$var$w,
        y: spawnAtBottom ? $125994b31ba2cef4$var$h + Math.random() * 200 : Math.random() * $125994b31ba2cef4$var$h,
        vy: 0.25 + Math.random() * 0.65,
        kickX: 0,
        kickY: 0,
        char: $125994b31ba2cef4$var$randomFrom($125994b31ba2cef4$var$CHARS),
        maxOpacity: 0.18 + Math.random() * 0.38,
        opacity: 0,
        size: 13 + Math.random() * 13,
        color: $125994b31ba2cef4$var$randomFrom($125994b31ba2cef4$var$palette()),
        charAge: 0,
        charLife: 40 + Math.floor(Math.random() * 80),
        wobble: Math.random() * Math.PI * 2
    };
}
function $125994b31ba2cef4$var$respawn(p) {
    p.x = Math.random() * $125994b31ba2cef4$var$w;
    p.y = $125994b31ba2cef4$var$h + 10 + Math.random() * 100;
    p.vy = 0.25 + Math.random() * 0.65;
    p.kickX = 0;
    p.kickY = 0;
    p.char = $125994b31ba2cef4$var$randomFrom($125994b31ba2cef4$var$CHARS);
    p.maxOpacity = 0.18 + Math.random() * 0.38;
    p.opacity = 0;
    p.size = 13 + Math.random() * 13;
    p.color = $125994b31ba2cef4$var$randomFrom($125994b31ba2cef4$var$palette());
    p.charAge = 0;
    p.charLife = 40 + Math.floor(Math.random() * 80);
    p.wobble = Math.random() * Math.PI * 2;
}
function $125994b31ba2cef4$var$repelFrom(x, y, strength = 1) {
    const radius = Math.max(150, Math.min($125994b31ba2cef4$var$w, $125994b31ba2cef4$var$h) * 0.28);
    const maxKick = 5.1 * strength;
    for (const p of $125994b31ba2cef4$var$particles){
        const dx = p.x - x;
        const dy = p.y - y;
        const dist = Math.hypot(dx, dy);
        if (dist > radius) continue;
        const falloff = 1 - dist / radius;
        const force = maxKick * falloff * falloff;
        const nx = dx / (dist || 1);
        const ny = dy / (dist || 1);
        p.kickX += nx * force;
        p.kickY += ny * force;
    }
}
function $125994b31ba2cef4$var$draw() {
    if ($125994b31ba2cef4$var$paused) {
        $125994b31ba2cef4$var$animId = requestAnimationFrame($125994b31ba2cef4$var$draw);
        return;
    }
    $125994b31ba2cef4$var$frame++;
    $125994b31ba2cef4$var$ctx.clearRect(0, 0, $125994b31ba2cef4$var$w, $125994b31ba2cef4$var$h);
    for (const p of $125994b31ba2cef4$var$particles){
        // Move upward
        p.y -= p.vy;
        // Horizontal wobble
        p.x += Math.sin($125994b31ba2cef4$var$frame * 0.018 + p.wobble) * 0.28;
        // Interaction impulse decay (touch/click ripple feel)
        p.x += p.kickX;
        p.y += p.kickY;
        p.kickX *= 0.9;
        p.kickY *= 0.9;
        // Compute opacity from vertical progress (fade in near bottom, fade out near top)
        const progress = 1 - p.y / $125994b31ba2cef4$var$h; // 0 = bottom, 1 = top
        if (progress < 0.12) p.opacity = progress / 0.12 * p.maxOpacity;
        else if (progress > 0.72) p.opacity = Math.max(0, (1 - progress) / 0.28 * p.maxOpacity);
        else p.opacity = p.maxOpacity;
        // Occasionally swap char
        p.charAge++;
        if (p.charAge >= p.charLife) {
            p.char = $125994b31ba2cef4$var$randomFrom($125994b31ba2cef4$var$CHARS);
            p.charAge = 0;
        }
        // Draw
        $125994b31ba2cef4$var$ctx.globalAlpha = p.opacity;
        $125994b31ba2cef4$var$ctx.fillStyle = p.color;
        $125994b31ba2cef4$var$ctx.font = `${p.size}px var(--font-mono, monospace)`;
        $125994b31ba2cef4$var$ctx.fillText(p.char, p.x, p.y);
        // Respawn if off-screen top
        if (p.y < -24) $125994b31ba2cef4$var$respawn(p);
    }
    $125994b31ba2cef4$var$ctx.globalAlpha = 1;
    $125994b31ba2cef4$var$animId = requestAnimationFrame($125994b31ba2cef4$var$draw);
}
function $125994b31ba2cef4$var$resize() {
    $125994b31ba2cef4$var$w = $125994b31ba2cef4$var$canvas.width = window.innerWidth;
    $125994b31ba2cef4$var$h = $125994b31ba2cef4$var$canvas.height = window.innerHeight;
}
function $125994b31ba2cef4$export$dae146ac3796f144(dark) {
    $125994b31ba2cef4$var$isDark = dark;
// Refresh particle colors on next respawn (gradual, natural)
}
function $125994b31ba2cef4$export$7f545ebf1bdfb9fd() {
    $125994b31ba2cef4$var$canvas = document.getElementById('bg-canvas');
    if (!$125994b31ba2cef4$var$canvas) return;
    $125994b31ba2cef4$var$ctx = $125994b31ba2cef4$var$canvas.getContext('2d');
    $125994b31ba2cef4$var$isDark = document.documentElement.dataset.theme !== 'light';
    $125994b31ba2cef4$var$resize();
    window.addEventListener('resize', $125994b31ba2cef4$var$resize, {
        passive: true
    });
    const onPointerDown = (e)=>{
        $125994b31ba2cef4$var$repelFrom(e.clientX, e.clientY, 1);
    };
    const onPointerMove = (e)=>{
        if (e.pointerType === 'touch' && e.isPrimary && e.buttons === 1) $125994b31ba2cef4$var$repelFrom(e.clientX, e.clientY, 0.65);
    };
    if ('PointerEvent' in window) {
        window.addEventListener('pointerdown', onPointerDown, {
            passive: true
        });
        window.addEventListener('pointermove', onPointerMove, {
            passive: true
        });
    } else {
        window.addEventListener('touchstart', (e)=>{
            const t = e.touches[0];
            if (!t) return;
            $125994b31ba2cef4$var$repelFrom(t.clientX, t.clientY, 1);
        }, {
            passive: true
        });
        window.addEventListener('click', (e)=>{
            $125994b31ba2cef4$var$repelFrom(e.clientX, e.clientY, 1);
        }, {
            passive: true
        });
    }
    // Spawn particles spread across canvas initially
    for(let i = 0; i < $125994b31ba2cef4$var$PARTICLE_COUNT; i++)$125994b31ba2cef4$var$particles.push($125994b31ba2cef4$var$makeParticle(false));
    // Pause when tab hidden
    document.addEventListener('visibilitychange', ()=>{
        $125994b31ba2cef4$var$paused = document.hidden;
    });
    $125994b31ba2cef4$var$draw();
}


const $db12283b528bfe21$var$STORAGE_KEY = 'rl-theme';
const $db12283b528bfe21$var$DARK_THEME_COLOR = '#070c09';
const $db12283b528bfe21$var$LIGHT_THEME_COLOR = '#f4f7f2';
const $db12283b528bfe21$var$THEME_PING_DURATION_MS = 520;
const $db12283b528bfe21$var$THEME_PING_BASE_SIZE_PX = 18;
let $db12283b528bfe21$var$isThemeTransitioning = false;
function $db12283b528bfe21$var$prefersReducedMotion() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function $db12283b528bfe21$var$getThemePingColor(theme) {
    if (theme === 'light') return '#1a5c38';
    return '#00e68a';
}
function $db12283b528bfe21$var$launchThemePing(originX, originY, nextTheme, onComplete) {
    if ($db12283b528bfe21$var$prefersReducedMotion()) {
        onComplete();
        return;
    }
    const ping = document.createElement('div');
    const maxRadius = Math.hypot(Math.max(originX, window.innerWidth - originX), Math.max(originY, window.innerHeight - originY));
    const targetScale = maxRadius * 2 / $db12283b528bfe21$var$THEME_PING_BASE_SIZE_PX;
    ping.dataset.themePing = 'true';
    Object.assign(ping.style, {
        position: 'fixed',
        left: `${originX}px`,
        top: `${originY}px`,
        width: `${$db12283b528bfe21$var$THEME_PING_BASE_SIZE_PX}px`,
        height: `${$db12283b528bfe21$var$THEME_PING_BASE_SIZE_PX}px`,
        borderRadius: '999px',
        border: `1.5px solid ${$db12283b528bfe21$var$getThemePingColor(nextTheme)}`,
        boxSizing: 'border-box',
        transform: 'translate(-50%, -50%) scale(0.35)',
        opacity: '0.92',
        pointerEvents: 'none',
        zIndex: '9998',
        boxShadow: `0 0 18px ${$db12283b528bfe21$var$getThemePingColor(nextTheme)}33`
    });
    document.body.appendChild(ping);
    function settlePing() {
        ping.remove();
        onComplete();
    }
    if (typeof ping.animate !== 'function') {
        settlePing();
        return;
    }
    const anim = ping.animate([
        {
            transform: 'translate(-50%, -50%) scale(0.35)',
            opacity: 0.92
        },
        {
            transform: `translate(-50%, -50%) scale(${targetScale})`,
            opacity: 0
        }
    ], {
        duration: $db12283b528bfe21$var$THEME_PING_DURATION_MS,
        easing: 'cubic-bezier(0.16, 0.84, 0.32, 1)',
        fill: 'forwards'
    });
    anim.onfinish = settlePing;
    anim.oncancel = settlePing;
}
function $db12283b528bfe21$var$getPreferred() {
    const stored = localStorage.getItem($db12283b528bfe21$var$STORAGE_KEY);
    if (stored) return stored;
    return 'dark';
}
function $db12283b528bfe21$var$applyTheme(theme) {
    document.documentElement.dataset.theme = theme;
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? $db12283b528bfe21$var$DARK_THEME_COLOR : $db12283b528bfe21$var$LIGHT_THEME_COLOR);
    (0, $125994b31ba2cef4$export$dae146ac3796f144)(theme === 'dark');
}
function $db12283b528bfe21$var$revealToggle(nextTheme) {
    if ($db12283b528bfe21$var$isThemeTransitioning) return;
    const btn = document.getElementById('theme-toggle');
    if (!btn) return;
    $db12283b528bfe21$var$isThemeTransitioning = true;
    const rect = btn.getBoundingClientRect();
    const ox = Math.round(rect.left + rect.width / 2);
    const oy = Math.round(rect.top + rect.height / 2);
    $db12283b528bfe21$var$applyTheme(nextTheme);
    localStorage.setItem($db12283b528bfe21$var$STORAGE_KEY, nextTheme);
    $db12283b528bfe21$var$launchThemePing(ox, oy, nextTheme, ()=>{
        $db12283b528bfe21$var$isThemeTransitioning = false;
    });
}
function $db12283b528bfe21$export$4c47704ed26c13e8() {
    const theme = $db12283b528bfe21$var$getPreferred();
    $db12283b528bfe21$var$applyTheme(theme);
    const btn = document.getElementById('theme-toggle');
    if (!btn) return;
    btn.addEventListener('click', ()=>{
        const current = document.documentElement.dataset.theme;
        $db12283b528bfe21$var$revealToggle(current === 'dark' ? 'light' : 'dark');
    });
}


// themeRipple.js — Subtle background ripple on theme-toggle press
const $f16cf0bf9eeac02d$var$RIPPLE_BASE_SIZE_PX = 22;
const $f16cf0bf9eeac02d$var$RIPPLE_DURATION_MS = 1800;
function $f16cf0bf9eeac02d$var$prefersReducedMotion() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function $f16cf0bf9eeac02d$var$getNextThemeColor() {
    const current = document.documentElement.dataset.theme;
    return current === 'dark' ? 'rgba(26, 92, 56, 0.16)' : 'rgba(0, 230, 138, 0.14)';
}
function $f16cf0bf9eeac02d$var$launchBackgroundRipple(originX, originY) {
    if ($f16cf0bf9eeac02d$var$prefersReducedMotion()) return;
    const maxRadius = Math.hypot(Math.max(originX, window.innerWidth - originX), Math.max(originY, window.innerHeight - originY));
    const targetScale = maxRadius * 2 / $f16cf0bf9eeac02d$var$RIPPLE_BASE_SIZE_PX;
    const ripple = document.createElement('div');
    ripple.dataset.themeRipple = 'true';
    Object.assign(ripple.style, {
        position: 'fixed',
        left: `${originX}px`,
        top: `${originY}px`,
        width: `${$f16cf0bf9eeac02d$var$RIPPLE_BASE_SIZE_PX}px`,
        height: `${$f16cf0bf9eeac02d$var$RIPPLE_BASE_SIZE_PX}px`,
        borderRadius: '999px',
        pointerEvents: 'none',
        zIndex: '0',
        opacity: '0',
        transform: 'translate(-50%, -50%) scale(0.35)',
        background: `radial-gradient(circle, ${$f16cf0bf9eeac02d$var$getNextThemeColor()} 0%, transparent 68%)`,
        filter: 'blur(1px)'
    });
    document.body.appendChild(ripple);
    function removeRipple() {
        ripple.remove();
    }
    if (typeof ripple.animate !== 'function') {
        window.setTimeout(removeRipple, $f16cf0bf9eeac02d$var$RIPPLE_DURATION_MS);
        return;
    }
    const anim = ripple.animate([
        {
            opacity: 0,
            transform: 'translate(-50%, -50%) scale(0.35)'
        },
        {
            opacity: 1,
            offset: 0.18
        },
        {
            opacity: 0,
            transform: `translate(-50%, -50%) scale(${targetScale})`
        }
    ], {
        duration: $f16cf0bf9eeac02d$var$RIPPLE_DURATION_MS,
        easing: 'cubic-bezier(0.12, 0.72, 0.24, 1)',
        fill: 'forwards'
    });
    anim.onfinish = removeRipple;
    anim.oncancel = removeRipple;
}
function $f16cf0bf9eeac02d$var$getButtonCenter(btn) {
    const rect = btn.getBoundingClientRect();
    return {
        x: Math.round(rect.left + rect.width / 2),
        y: Math.round(rect.top + rect.height / 2)
    };
}
function $f16cf0bf9eeac02d$export$a81996a24dad625e() {
    const btn = document.getElementById('theme-toggle');
    if (!btn) return;
    btn.addEventListener('pointerdown', (event)=>{
        $f16cf0bf9eeac02d$var$launchBackgroundRipple(event.clientX, event.clientY);
    });
    btn.addEventListener('keydown', (event)=>{
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const { x: x, y: y } = $f16cf0bf9eeac02d$var$getButtonCenter(btn);
        $f16cf0bf9eeac02d$var$launchBackgroundRipple(x, y);
    });
}



// headerPulse.js — Randomized energy pulse running along nav divider
const $9661a72e87c49808$var$MIN_DELAY = 7000;
const $9661a72e87c49808$var$MAX_DELAY = 25000;
function $9661a72e87c49808$var$randomDelay() {
    return Math.floor($9661a72e87c49808$var$MIN_DELAY + Math.random() * ($9661a72e87c49808$var$MAX_DELAY - $9661a72e87c49808$var$MIN_DELAY));
}
function $9661a72e87c49808$export$c59ca973c9c8e2b4() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const nav = document.getElementById('site-nav');
    if (!nav) return;
    const pulse = document.createElement('span');
    pulse.className = 'nav-divider-pulse';
    pulse.setAttribute('aria-hidden', 'true');
    nav.appendChild(pulse);
    let timer = null;
    function getTravelBounds() {
        const navWidth = nav.getBoundingClientRect().width;
        const pulseWidth = pulse.getBoundingClientRect().width || 26;
        const overshoot = pulseWidth + 18;
        return {
            start: `${-overshoot}px`,
            end: `${Math.ceil(navWidth + overshoot)}px`
        };
    }
    const schedule = ()=>{
        if (timer) clearTimeout(timer);
        timer = setTimeout(runPulse, $9661a72e87c49808$var$randomDelay());
    };
    const runPulse = ()=>{
        const { start: start, end: end } = getTravelBounds();
        pulse.style.setProperty('--pulse-from', start);
        pulse.style.setProperty('--pulse-to', end);
        pulse.classList.remove('is-animating');
        // restart animation
        pulse.offsetWidth;
        pulse.classList.add('is-animating');
        schedule();
    };
    document.addEventListener('visibilitychange', ()=>{
        if (document.hidden) {
            if (timer) clearTimeout(timer);
            timer = null;
            pulse.classList.remove('is-animating');
        } else schedule();
    });
    schedule();
}


// parallax.js — Scroll-based depth layers
let $3189ab585e078354$var$deepEl, $3189ab585e078354$var$midEl;
let $3189ab585e078354$var$targetY = 0;
let $3189ab585e078354$var$currentY = 0;
let $3189ab585e078354$var$ticking = false;
let $3189ab585e078354$var$enabled = true;
function $3189ab585e078354$var$update() {
    $3189ab585e078354$var$ticking = false;
    // Lerp for smoothness
    $3189ab585e078354$var$currentY += ($3189ab585e078354$var$targetY - $3189ab585e078354$var$currentY) * 0.08;
    // As the section scrolls out, counteract at different rates so each layer
    // appears at a different depth. Lower factor = slower exit = appears deeper.
    if ($3189ab585e078354$var$deepEl) $3189ab585e078354$var$deepEl.style.transform = `translateY(${$3189ab585e078354$var$currentY * 0.55}px)`;
    if ($3189ab585e078354$var$midEl) $3189ab585e078354$var$midEl.style.transform = `translateY(${$3189ab585e078354$var$currentY * 0.28}px)`;
    if (Math.abs($3189ab585e078354$var$targetY - $3189ab585e078354$var$currentY) > 0.1) {
        requestAnimationFrame($3189ab585e078354$var$update);
        $3189ab585e078354$var$ticking = true;
    }
}
function $3189ab585e078354$var$onScroll() {
    if (!$3189ab585e078354$var$enabled) return;
    $3189ab585e078354$var$targetY = window.scrollY;
    if (!$3189ab585e078354$var$ticking) {
        $3189ab585e078354$var$ticking = true;
        requestAnimationFrame($3189ab585e078354$var$update);
    }
}
function $3189ab585e078354$export$d11e21666c6a970d() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    $3189ab585e078354$var$deepEl = document.querySelector('.parallax-deep');
    $3189ab585e078354$var$midEl = document.querySelector('.parallax-mid');
    // Keep hero text anchored to layout (no parallax on foreground copy),
    // so subtitle/CTA don't "bounce" after scroll settles.
    const fgEl = document.querySelector('.parallax-fg');
    if (fgEl) fgEl.style.transform = 'none';
    window.addEventListener('scroll', $3189ab585e078354$var$onScroll, {
        passive: true
    });
}


// reveal.js — IntersectionObserver scroll-in animations
// scramble.js — Matrix-style text decode effect
const $04b1d59d095bb6e8$var$SCRAMBLE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
function $04b1d59d095bb6e8$export$e7459906f76aa375(el, { duration: duration = 900, delay: delay = 0, onComplete: onComplete } = {}) {
    const finalText = el.dataset.final || el.textContent.trim();
    if (!finalText) return;
    let didComplete = false;
    function finish() {
        if (didComplete) return;
        didComplete = true;
        onComplete?.();
    }
    // Respect prefers-reduced-motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = finalText;
        finish();
        return;
    }
    let startTime = null;
    function tick(ts) {
        if (startTime === null) startTime = ts + delay;
        if (ts < startTime) {
            // Show scrambled text during delay
            el.textContent = $04b1d59d095bb6e8$var$randomString(finalText.length);
            requestAnimationFrame(tick);
            return;
        }
        const elapsed = ts - startTime;
        const progress = Math.min(elapsed / duration, 1);
        // Resolve characters left-to-right based on progress
        const resolvedCount = Math.floor(// Ease in the resolution — slow at first, then rushes to finish
        $04b1d59d095bb6e8$var$easeInQuart(progress) * finalText.length);
        let display = '';
        for(let i = 0; i < finalText.length; i++){
            if (i < resolvedCount) display += finalText[i];
            else if (finalText[i] === ' ') display += ' ';
            else display += $04b1d59d095bb6e8$var$SCRAMBLE_CHARS[Math.floor(Math.random() * $04b1d59d095bb6e8$var$SCRAMBLE_CHARS.length)];
        }
        el.textContent = display;
        if (progress < 1) requestAnimationFrame(tick);
        else {
            el.textContent = finalText;
            finish();
        }
    }
    requestAnimationFrame(tick);
}
function $04b1d59d095bb6e8$var$randomString(length) {
    let s = '';
    for(let i = 0; i < length; i++)s += $04b1d59d095bb6e8$var$SCRAMBLE_CHARS[Math.floor(Math.random() * $04b1d59d095bb6e8$var$SCRAMBLE_CHARS.length)];
    return s;
}
function $04b1d59d095bb6e8$var$easeInQuart(t) {
    return t * t * t * t;
}


const $968e49bc9b5b83e7$var$CARD_STAGGER_MS = 90;
function $968e49bc9b5b83e7$var$observeSections() {
    const sections = document.querySelectorAll('.reveal-section');
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.12
    });
    sections.forEach((el)=>observer.observe(el));
}
function $968e49bc9b5b83e7$var$observeCards() {
    const cards = document.querySelectorAll('.reveal-card');
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            const card = entry.target;
            const index = parseInt(card.dataset.index ?? '0', 10);
            setTimeout(()=>{
                card.classList.add('visible');
                // Trigger scramble on card title
                const titleEl = card.querySelector('.scramble-target');
                if (titleEl) (0, $04b1d59d095bb6e8$export$e7459906f76aa375)(titleEl, {
                    duration: 800,
                    delay: 0
                });
            }, index * $968e49bc9b5b83e7$var$CARD_STAGGER_MS);
            observer.unobserve(card);
        });
    }, {
        threshold: 0.1
    });
    cards.forEach((el)=>observer.observe(el));
}
function $968e49bc9b5b83e7$export$8175101c94c0e570() {
    $968e49bc9b5b83e7$var$observeSections();
    $968e49bc9b5b83e7$var$observeCards();
}


// cursor.js — Custom cursor + magnetic card tilt
let $228183752b4dcb35$var$dot, $228183752b4dcb35$var$ring;
let $228183752b4dcb35$var$mouseX = -100, $228183752b4dcb35$var$mouseY = -100;
let $228183752b4dcb35$var$ringX = -100, $228183752b4dcb35$var$ringY = -100;
let $228183752b4dcb35$var$hovering = false;
function $228183752b4dcb35$var$lerp(a, b, t) {
    return a + (b - a) * t;
}
function $228183752b4dcb35$var$animateRing() {
    $228183752b4dcb35$var$ringX = $228183752b4dcb35$var$lerp($228183752b4dcb35$var$ringX, $228183752b4dcb35$var$mouseX, 0.13);
    $228183752b4dcb35$var$ringY = $228183752b4dcb35$var$lerp($228183752b4dcb35$var$ringY, $228183752b4dcb35$var$mouseY, 0.13);
    $228183752b4dcb35$var$ring.style.transform = `translate(${$228183752b4dcb35$var$ringX - 17}px, ${$228183752b4dcb35$var$ringY - 17}px)`;
    requestAnimationFrame($228183752b4dcb35$var$animateRing);
}
function $228183752b4dcb35$export$c4d12dff0a005262() {
    $228183752b4dcb35$var$dot = document.getElementById('cursor-dot');
    $228183752b4dcb35$var$ring = document.getElementById('cursor-ring');
    if (!$228183752b4dcb35$var$dot || !$228183752b4dcb35$var$ring) return;
    document.body.classList.add('has-custom-cursor');
    document.addEventListener('mousemove', (e)=>{
        $228183752b4dcb35$var$mouseX = e.clientX;
        $228183752b4dcb35$var$mouseY = e.clientY;
        $228183752b4dcb35$var$dot.style.transform = `translate(${$228183752b4dcb35$var$mouseX - 2.5}px, ${$228183752b4dcb35$var$mouseY - 2.5}px)`;
        $228183752b4dcb35$var$dot.style.opacity = '1';
        $228183752b4dcb35$var$ring.style.opacity = '';
    });
    document.addEventListener('mouseleave', ()=>{
        $228183752b4dcb35$var$dot.style.opacity = '0';
        $228183752b4dcb35$var$ring.style.opacity = '0';
    });
    document.addEventListener('mouseenter', ()=>{
        $228183752b4dcb35$var$dot.style.opacity = '1';
        $228183752b4dcb35$var$ring.style.opacity = '';
    });
    window.addEventListener('blur', ()=>{
        $228183752b4dcb35$var$dot.style.opacity = '0';
        $228183752b4dcb35$var$ring.style.opacity = '0';
        document.body.classList.remove('cursor-hover');
    });
    window.addEventListener('focus', ()=>{
        $228183752b4dcb35$var$dot.style.opacity = '1';
        $228183752b4dcb35$var$ring.style.opacity = '';
    });
    $228183752b4dcb35$var$animateRing();
    $228183752b4dcb35$var$initCardTilt();
}
function $228183752b4dcb35$var$initCardTilt() {
    const cards = document.querySelectorAll('.project-card');
    cards.forEach((card)=>{
        const glow = card.querySelector('.card-glow');
        card.addEventListener('mouseenter', ()=>{
            document.body.classList.add('cursor-hover');
        });
        card.addEventListener('mouseleave', ()=>{
            document.body.classList.remove('cursor-hover');
            card.style.transform = '';
            if (glow) glow.style.background = '';
        });
        card.addEventListener('mousemove', (e)=>{
            const rect = card.getBoundingClientRect();
            const cx = rect.left + rect.width / 2;
            const cy = rect.top + rect.height / 2;
            // Normalized -1..1
            const dx = (e.clientX - cx) / (rect.width / 2);
            const dy = (e.clientY - cy) / (rect.height / 2);
            // Tilt (max ±8deg)
            const tiltX = dy * -7;
            const tiltY = dx * 7;
            card.style.transform = `perspective(900px) rotateX(${tiltX}deg) rotateY(${tiltY}deg) translateZ(6px)`;
            // Move glow to cursor position
            if (glow) {
                const gx = (e.clientX - rect.left) / rect.width * 100;
                const gy = (e.clientY - rect.top) / rect.height * 100;
                glow.style.background = `radial-gradient(circle at ${gx}% ${gy}%, var(--card-glow) 0%, transparent 60%)`;
            }
        });
    });
    // Expand ring on any interactive element
    const interactives = document.querySelectorAll('a, button');
    interactives.forEach((el)=>{
        el.addEventListener('mouseenter', ()=>document.body.classList.add('cursor-hover'));
        el.addEventListener('mouseleave', ()=>document.body.classList.remove('cursor-hover'));
    });
}



// github.js — Populates the nav GitHub summary and 14-day contribution heatmap.
function $9fdb7b19816fbb43$var$ordinalDay(n) {
    if (n >= 11 && n <= 13) return `${n}th`;
    switch(n % 10){
        case 1:
            return `${n}st`;
        case 2:
            return `${n}nd`;
        case 3:
            return `${n}rd`;
        default:
            return `${n}th`;
    }
}
// Single tooltip element appended to <body> so it's never clipped by nav overflow.
function $9fdb7b19816fbb43$var$getTooltip() {
    let el = document.getElementById('commit-tooltip');
    if (!el) {
        el = document.createElement('div');
        el.id = 'commit-tooltip';
        document.body.appendChild(el);
    }
    return el;
}
function $9fdb7b19816fbb43$var$formatSummary(contributionTotal) {
    return Number.isFinite(contributionTotal) ? contributionTotal.toLocaleString('en-US') : '--';
}
async function $9fdb7b19816fbb43$export$36d02818238e79e4() {
    // Build 14-day key list, oldest first (day 14 → day 1 = yesterday)
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dayKeys = [];
    for(let i = 14; i >= 1; i--){
        const d = new Date(today);
        d.setDate(d.getDate() - i);
        dayKeys.push(d.toISOString().slice(0, 10));
    }
    const dayMap = Object.fromEntries(dayKeys.map((k)=>[
            k,
            0
        ]));
    let contributionTotal = null;
    try {
        const res = await fetch('/.netlify/functions/github');
        if (res.ok) {
            const data = await res.json();
            const { days: days = {}, yearContributionTotal: yearContributionTotal } = data;
            for (const key of dayKeys)if (key in days) dayMap[key] = days[key];
            contributionTotal = Number.isFinite(yearContributionTotal) ? yearContributionTotal : null;
        }
    } catch (_) {
    // Running without netlify dev — squares stay empty, that's fine
    }
    const summary = $9fdb7b19816fbb43$var$formatSummary(contributionTotal);
    const contributionEl = document.getElementById('github-year-count');
    if (contributionEl) contributionEl.textContent = summary;
    // ── Render commit squares ─────────────────────────────
    const tooltip = $9fdb7b19816fbb43$var$getTooltip();
    let total = 0;
    const boxes = document.querySelectorAll('.commit-day');
    boxes.forEach((box, i)=>{
        const key = dayKeys[i];
        const count = dayMap[key] ?? 0;
        total += count;
        const level = count === 0 ? 0 : count <= 2 ? 1 : count <= 5 ? 2 : 3;
        box.dataset.level = level;
        const d = new Date(key + 'T12:00:00');
        const month = d.toLocaleDateString('en-US', {
            month: 'long'
        });
        const day = $9fdb7b19816fbb43$var$ordinalDay(d.getDate());
        const tip = count === 0 ? `No contributions on ${month} ${day}.` : count === 1 ? `1 contribution on ${month} ${day}.` : `${count} contributions on ${month} ${day}.`;
        box.addEventListener('mouseenter', (e)=>{
            tooltip.textContent = tip;
            tooltip.classList.add('visible');
            tooltip.style.left = `${e.clientX}px`;
            tooltip.style.top = `${e.clientY + 20}px`;
        });
        box.addEventListener('mousemove', (e)=>{
            tooltip.style.left = `${e.clientX}px`;
            tooltip.style.top = `${e.clientY + 20}px`;
        });
        box.addEventListener('mouseleave', ()=>{
            tooltip.classList.remove('visible');
        });
    });
    // ── Render 14-day total ───────────────────────────────
    const countEl = document.getElementById('commit-count');
    if (countEl) countEl.textContent = total;
}


// weather.js — Fetches current temperature for SF 94110 from Open-Meteo.
// Free, no API key, CORS-friendly. Refreshes every 5 minutes.
async function $142771476da5e953$export$fe12e2131efe2516() {
    const el = document.getElementById("weather-temp");
    if (!el) return;
    // 94110 = Mission District, San Francisco
    const URL = "https://api.open-meteo.com/v1/forecast?latitude=37.7483&longitude=-122.4153&current=temperature_2m&temperature_unit=fahrenheit&forecast_days=1";
    async function fetchTemp() {
        try {
            const res = await fetch(URL);
            if (!res.ok) return;
            const data = await res.json();
            const temp = data.current?.temperature_2m;
            if (temp != null) el.textContent = `${temp.toFixed(1)}\xb0F`;
        } catch (_) {
        // No network or API down — leave as —
        }
    }
    fetchTemp();
    setInterval(fetchTemp, 300000); // refresh every 5 min
}


function $54b47fc030b7b21e$var$forceScrollTop() {
    const root = document.documentElement;
    const prevBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, 0);
    // Double-set on next frame to beat browser restoration race conditions.
    requestAnimationFrame(()=>{
        window.scrollTo(0, 0);
        root.style.scrollBehavior = prevBehavior;
    });
}
function $54b47fc030b7b21e$var$lockTextFootprint(el) {
    const finalText = el.dataset.final || el.textContent.trim();
    if (!finalText) return;
    const probe = document.createElement('span');
    const cs = window.getComputedStyle(el);
    probe.textContent = finalText;
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.whiteSpace = 'pre';
    probe.style.fontFamily = cs.fontFamily;
    probe.style.fontSize = cs.fontSize;
    probe.style.fontWeight = cs.fontWeight;
    probe.style.letterSpacing = cs.letterSpacing;
    probe.style.lineHeight = cs.lineHeight;
    document.body.appendChild(probe);
    const { width: width } = probe.getBoundingClientRect();
    probe.remove();
    const parentWidth = el.parentElement?.clientWidth ?? window.innerWidth;
    const lockedWidth = Math.min(Math.ceil(width), Math.max(0, Math.floor(parentWidth)));
    el.style.display = 'inline-block';
    el.style.width = `${lockedWidth}px`;
    el.style.maxWidth = '100%';
    el.style.whiteSpace = 'nowrap';
    el.style.textAlign = 'center';
}
function $54b47fc030b7b21e$var$createHeroScrambleOverlay(baseEl) {
    const headline = baseEl.closest('.hero-headline');
    if (!headline) return null;
    const computedHeadline = window.getComputedStyle(headline);
    if (computedHeadline.position === 'static') headline.style.position = 'relative';
    const computedBase = window.getComputedStyle(baseEl);
    const overlay = document.createElement('span');
    overlay.dataset.heroScrambleOverlay = 'true';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.textContent = baseEl.dataset.final || baseEl.textContent.trim();
    Object.assign(overlay.style, {
        position: 'absolute',
        inset: '0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
        fontFamily: computedBase.fontFamily,
        fontSize: computedBase.fontSize,
        fontWeight: computedBase.fontWeight,
        fontStyle: computedBase.fontStyle,
        lineHeight: computedBase.lineHeight,
        letterSpacing: computedBase.letterSpacing,
        color: computedBase.color
    });
    headline.appendChild(overlay);
    return overlay;
}
function $54b47fc030b7b21e$var$measureTextWidth(el, text) {
    const probe = document.createElement('span');
    const cs = window.getComputedStyle(el);
    probe.textContent = text;
    probe.style.position = 'absolute';
    probe.style.visibility = 'hidden';
    probe.style.whiteSpace = 'pre';
    probe.style.fontFamily = cs.fontFamily;
    probe.style.fontSize = cs.fontSize;
    probe.style.fontWeight = cs.fontWeight;
    probe.style.fontStyle = cs.fontStyle;
    probe.style.letterSpacing = cs.letterSpacing;
    probe.style.lineHeight = cs.lineHeight;
    document.body.appendChild(probe);
    const { width: width } = probe.getBoundingClientRect();
    probe.remove();
    return width;
}
function $54b47fc030b7b21e$var$measureHeroSubWordWidths(word) {
    if (!word) return null;
    const finalWord = word.dataset.final?.trim() || word.textContent.trim();
    const altWord = word.dataset.alt?.trim();
    if (!finalWord || !altWord) return null;
    const finalWordWidth = Math.ceil($54b47fc030b7b21e$var$measureTextWidth(word, finalWord));
    const altWordWidth = Math.ceil($54b47fc030b7b21e$var$measureTextWidth(word, altWord));
    return {
        finalWordWidth: finalWordWidth,
        altWordWidth: altWordWidth
    };
}
function $54b47fc030b7b21e$var$initHeroSubEdit() {
    const word = document.querySelector('.hero-edit-word');
    const phrase = document.querySelector('.hero-sub-phrase');
    if (!word || !phrase) return;
    const initialDelayMs = 3000;
    const swapDurationMs = 260;
    const finalWord = word.dataset.final?.trim() || word.textContent.trim();
    const altWord = word.dataset.alt?.trim();
    if (!finalWord || !altWord) return;
    let hasStarted = false;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const showReduced = ()=>{
            const widths = $54b47fc030b7b21e$var$measureHeroSubWordWidths(word);
            word.textContent = finalWord;
            if (widths) word.style.width = `${widths.finalWordWidth}px`;
            phrase.classList.add('is-ready');
        };
        if (document.fonts?.ready) document.fonts.ready.then(showReduced);
        else showReduced();
        return;
    }
    const syncHeroSubWordLayout = ()=>{
        const widths = $54b47fc030b7b21e$var$measureHeroSubWordWidths(word);
        if (!widths) return;
        word.style.width = word.textContent.trim() === finalWord ? `${widths.finalWordWidth}px` : `${widths.altWordWidth}px`;
    };
    const start = ()=>{
        if (hasStarted) return;
        hasStarted = true;
        word.textContent = altWord;
        const widths = $54b47fc030b7b21e$var$measureHeroSubWordWidths(word);
        if (!widths) return;
        const { finalWordWidth: finalWordWidth, altWordWidth: altWordWidth } = widths;
        word.style.width = `${altWordWidth}px`;
        phrase.classList.add('is-ready');
        window.setTimeout(()=>{
            requestAnimationFrame(()=>{
                word.classList.add('is-swapping');
            });
            window.setTimeout(()=>{
                word.textContent = finalWord;
                word.style.width = `${finalWordWidth}px`;
                requestAnimationFrame(()=>{
                    word.classList.remove('is-swapping');
                });
            }, swapDurationMs);
        }, initialDelayMs);
    };
    let rafId = null;
    const relayoutPhrase = ()=>{
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(()=>{
            syncHeroSubWordLayout();
        });
    };
    window.addEventListener('resize', relayoutPhrase, {
        passive: true
    });
    window.addEventListener('orientationchange', relayoutPhrase, {
        passive: true
    });
    if (document.fonts?.ready) document.fonts.ready.then(()=>{
        relayoutPhrase();
        start();
    });
    else {
        relayoutPhrase();
        start();
    }
}
function $54b47fc030b7b21e$var$initClock() {
    const el = document.getElementById('ca-clock');
    if (!el) return;
    const hideClockMq = window.matchMedia('(max-width: 374px)');
    const syncClockVisibility = ()=>{
        const shouldHide = hideClockMq.matches;
        el.hidden = shouldHide;
        el.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
        el.style.display = shouldHide ? 'none' : '';
    };
    function tick() {
        const now = new Date();
        // California = America/Los_Angeles (handles PST/PDT automatically)
        const time = now.toLocaleTimeString('en-US', {
            timeZone: 'America/Los_Angeles',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
        });
        // Append PST or PDT depending on daylight saving time
        const tz = now.toLocaleDateString('en-US', {
            timeZone: 'America/Los_Angeles',
            timeZoneName: 'short'
        }).split(', ')[1] ?? 'PT';
        el.textContent = `${time} ${tz}`;
        el.setAttribute('datetime', now.toISOString());
    }
    syncClockVisibility();
    hideClockMq.addEventListener('change', syncClockVisibility);
    tick();
    setInterval(tick, 1000);
}
function $54b47fc030b7b21e$var$initFooterQuotes() {
    const el = document.getElementById('footer-quote');
    if (!el) return;
    const quotes = [
        [
            'wealth is in the mind,',
            'not the pocket'
        ],
        [
            'Practice the art of interpreting',
            'situations constructively'
        ],
        [
            'The dog that walks around',
            'will find the stick'
        ],
        [
            'Too many accomplishments',
            'make no accomplishment'
        ],
        [
            'Dumplings are',
            'better than flowers'
        ],
        [
            'All you need is less'
        ]
    ];
    const renderQuote = ([firstLine, secondLine])=>{
        el.replaceChildren();
        el.append(document.createTextNode(firstLine));
        if (!secondLine) return;
        const breakEl = document.createElement('span');
        breakEl.className = 'footer-mobile-break';
        breakEl.setAttribute('aria-hidden', 'true');
        el.append(breakEl, document.createTextNode(secondLine));
    };
    const randomIndex = Math.floor(Math.random() * quotes.length);
    renderQuote(quotes[randomIndex]);
}
function $54b47fc030b7b21e$export$3ba5eeda59441f39(heroTarget = document.querySelector('.hero-content .scramble-target')) {
    if (!heroTarget) return;
    const finalText = heroTarget.dataset.final || heroTarget.textContent.trim();
    if (!finalText) return;
    let rafId = null;
    const relockHero = ()=>{
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(()=>$54b47fc030b7b21e$var$lockTextFootprint(heroTarget));
    };
    const startHero = ()=>{
        heroTarget.textContent = finalText;
        $54b47fc030b7b21e$var$lockTextFootprint(heroTarget);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            heroTarget.style.removeProperty('color');
            return;
        }
        const overlay = $54b47fc030b7b21e$var$createHeroScrambleOverlay(heroTarget);
        if (!overlay) return;
        const previousInlineColor = heroTarget.style.color;
        heroTarget.style.color = 'transparent';
        (0, $04b1d59d095bb6e8$export$e7459906f76aa375)(overlay, {
            duration: 1100,
            delay: 350,
            onComplete: ()=>{
                overlay.remove();
                if (previousInlineColor) heroTarget.style.color = previousInlineColor;
                else heroTarget.style.removeProperty('color');
            }
        });
        window.addEventListener('resize', relockHero, {
            passive: true
        });
        window.addEventListener('orientationchange', relockHero, {
            passive: true
        });
    };
    if (document.fonts?.ready) document.fonts.ready.then(startHero);
    else startHero();
}
document.addEventListener('DOMContentLoaded', ()=>{
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    $54b47fc030b7b21e$var$forceScrollTop();
    $54b47fc030b7b21e$var$initClock();
    // Theme must be first (prevents flash)
    (0, $db12283b528bfe21$export$4c47704ed26c13e8)();
    (0, $f16cf0bf9eeac02d$export$a81996a24dad625e)();
    (0, $9661a72e87c49808$export$c59ca973c9c8e2b4)();
    // Canvas particle background
    (0, $125994b31ba2cef4$export$7f545ebf1bdfb9fd)();
    // Parallax depth layers
    (0, $3189ab585e078354$export$d11e21666c6a970d)();
    // Scroll-reveal + card scrambles
    (0, $968e49bc9b5b83e7$export$8175101c94c0e570)();
    // Custom cursor + card tilt (non-touch only)
    if (window.matchMedia('(pointer: fine)').matches) (0, $228183752b4dcb35$export$c4d12dff0a005262)();
    // GitHub 14-day commit strip (non-blocking, no token needed)
    (0, $9fdb7b19816fbb43$export$36d02818238e79e4)();
    // SF 94110 live temperature
    (0, $142771476da5e953$export$fe12e2131efe2516)();
    // Hero subline self-correction joke
    $54b47fc030b7b21e$var$initHeroSubEdit();
    // Footer quote rotation with mobile-specific line breaks
    $54b47fc030b7b21e$var$initFooterQuotes();
    // Hero headline scramble on load
    $54b47fc030b7b21e$export$3ba5eeda59441f39();
});
window.addEventListener('pageshow', ()=>{
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    $54b47fc030b7b21e$var$forceScrollTop();
});
window.addEventListener('load', $54b47fc030b7b21e$var$forceScrollTop, {
    once: true
});


//# sourceMappingURL=repo.6d2b9d83.js.map
